module.exports = __webpack_public_path__ + "static/media/image_21.e735f468.png";